module.exports = __webpack_public_path__ + "static/media/joyable5.551cea82.jpg";